import React, { FC } from 'react';

import { Box, HStack, Text } from '@rbilabs/universal-components';
import { usePaymentContext } from 'features/payment';
import { IPaymentMethod } from 'features/payment/types';

import Currency from 'components/currency';
import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';
interface IPrepaidMethodBalance {
  method: IPaymentMethod;
  isDisabled?: boolean;
  isRedesign?: boolean;
}

const PrepaidMethodBalance: FC<IPrepaidMethodBalance> = ({
  method,
  isDisabled = false,
  isRedesign = false,
}) => {
  const { getBalanceFromPaymentMethods } = usePaymentContext();

  if (isRedesign) {
    return (
      <Box alignItems="flex-start" flexDirection="column">
        <Text
          color={isDisabled ? getDesignToken('text-disabled') : getDesignToken('text-default')}
          variant="headerTwo"
          fontSize="lg"
          mb="$1"
        >
          {t('giftCard')}
        </Text>
        <Currency
          amount={getBalanceFromPaymentMethods(method)}
          textProps={{
            margin: 0,
          }}
        />
      </Box>
    );
  }

  return (
    <HStack space="$2" alignItems="center">
      <Text color={isDisabled ? getDesignToken('text-disabled') : getDesignToken('text-default')}>
        {t('giftCard')}
      </Text>
      <Currency
        amount={getBalanceFromPaymentMethods(method)}
        textProps={{
          margin: 0,
        }}
      />
    </HStack>
  );
};

export default PrepaidMethodBalance;
